import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ role, children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen grid place-items-center bg-white">
        <div className="font-mono text-[11px] tracking-[0.18em] uppercase text-gray-400 animate-pulse">
          Authenticating…
        </div>
      </div>
    );
  }
  if (!user) {
    return <Navigate to={`/login?role=${role || "driver"}`} replace state={{ from: location.pathname }} />;
  }
  if (role && user.role !== role) {
    const dest = user.role === "admin" ? "/admin" : user.role === "merchant" ? "/merchant" : "/driver";
    return <Navigate to={dest} replace />;
  }
  return children;
}
